export default {
  common: {
    bingWallpaper: 'Bing Wallpaper',
    home: 'Accueil',
    about: 'À propos',
    blog: 'Blog',
    refresh: 'Actualiser la page',
    loading: 'Chargement...',
    year: '',
    preview: 'Aperçu',
    close: 'Fermer',
    today: 'Aujourd\'hui',
    yesterday: 'Hier',
    dayBefore: 'Avant-hier',
    daysAgo: 'jours',
    monthsAgo: 'mois',
    yearsAgo: 'ans',
    unknown: 'Inconnu',
    copySuccess: 'Copié dans le presse-papiers',
    copyFail: 'Échec de la copie, veuillez copier manuellement',
    language: 'Langue',
    chinese: '中文',
    english: 'English',
    visitorCount: 'Vous êtes le {count}ème visiteur',
    copyright: 'Toutes les images de ce site proviennent de la recherche Bing, uniquement à des fins d\'apprentissage et d\'usage personnel',
    footerCopyright: 'Copyright © 2022 - {year}',
    openMenu: 'Ouvrir le menu',
    fatalError: 'Échec du chargement de la page, veuillez actualiser et réessayer',
    regionChina: 'Chine',
    regionGermany: 'Allemagne',
    regionCanada: 'Canada',
    regionUK: 'Royaume-Uni',
    regionIndia: 'Inde',
    regionUS: 'États-Unis',
    regionFrance: 'France',
    regionItaly: 'Italie',
    regionJapan: 'Japon',
    netdiskQuark: 'Quark Drive',
    netdiskAlipan: 'Alipan Drive',
    downloadViaNetdisk: 'Télécharger les fonds d\'écran HD',
    use: 'via'
  },
  wallpaper: {
    siteTitle: 'Bing Wallpaper - Microsoft Bing fonds d\'écran HD quotidiens à télécharger',
    siteDesc: 'Site de téléchargement Bing Wallpaper, synchronisant chaque jour les fonds d\'écran officiels quotidiens de {strong}Microsoft Bing{/strong}. Parcourez et téléchargez des fonds d\'écran Bing de {strong}Chine, États-Unis, Japon, Allemagne, Royaume-Uni, France, Italie, Canada, Inde{/strong} et plus. Prend en charge {strong}4K, 1920x1080, 1920x1200, 1366x768{/strong} et d\'autres résolutions. Filtrez par année et {strong}téléchargement groupé{/strong} de tous les fonds d\'écran. Tous les fonds d\'écran HD sont gratuits, parfaits pour les arrière-plans de bureau et de téléphone.',
    regionFilter: 'Région',
    resolutionFilter: 'Résolution',
    yearFilter: 'Année',
    selectRegion: 'Sélectionner la région',
    selectResolution: 'Sélectionner la taille',
    selectYear: 'Sélectionner l\'année',
    yearHint: 'Sélectionnez une année pour télécharger tous les fonds d\'écran de cette année',
    currentFilter: 'Filtre actuel',
    totalWallpapers: '{count} fonds d\'écran',
    batchDownload: 'Téléchargement groupé',
    downloadingWallpapers: 'Téléchargement des fonds d\'écran...',
    packaging: 'Empaquetage...',
    downloadSuccess: '{count} fonds d\'écran téléchargés avec succès',
    downloadFailed: 'Échec du téléchargement groupé, veuillez réessayer',
    noWallpapers: 'Aucun fond d\'écran disponible au téléchargement',
    noResults: 'Aucun fond d\'écran ne correspond aux critères',
    clearFilters: 'Effacer les filtres',
    filterRegion: 'Région',
    filterYear: 'Année',
    filterResolution: 'Taille',
    fetchFailed: 'Échec de la récupération des données de fonds d\'écran',
    fetchFailedNetwork: 'Échec de la récupération des données, veuillez vérifier votre réseau',
    unknownError: 'Erreur inconnue',
    yearSuffix: ''
  },
  detail: {
    viewOriginal: 'Voir l\'original',
    backHome: 'Retour à l\'accueil',
    downloadWallpaper: 'Télécharger',
    copyLink: 'Copier le lien',
    viewFullscreen: 'Plein écran',
    fullscreenTooltip: 'Cliquez sur l\'image du fond d\'écran pour la voir en plein écran',
    imageDescription: 'Description',
    viewSource: 'Voir la source',
    openOriginal: 'Ouvrir l\'original',
    copyrightInfo: 'Copyright',
    publishDate: 'Date',
    switchResolution: 'Changer de résolution',
    recommended: 'Plus de fonds d\'écran',
    loadingDetail: 'Chargement des détails du fond d\'écran...',
    loadFailed: 'Échec du chargement',
    reload: 'Réessayer',
    loadingImage: 'Chargement de l\'image...',
    imageLoadFailed: 'Échec du chargement de l\'image',
    missingId: 'Paramètre ID du fond d\'écran manquant',
    notFound: 'Fond d\'écran introuvable',
    fetchDetailFailed: 'Échec de la récupération des détails du fond d\'écran',
    networkError: 'Erreur réseau, veuillez vérifier votre connexion et réessayer',
    resolutionSwitched: 'Résolution changée à {resolution}',
    startDownload: 'Démarrage du téléchargement du fond d\'écran',
    linkCopied: 'Lien de l\'image copié dans le presse-papiers',
    setDesktopHint: 'Cliquez avec le bouton droit sur l\'image et sélectionnez "Définir comme arrière-plan du bureau"',
    alreadyFavorited: 'Ce fond d\'écran est déjà dans vos favoris',
    favoriteSuccess: 'Fond d\'écran ajouté aux favoris',
    copyFailedManual: 'Échec de la copie, veuillez copier manuellement',
    wechatShareHint: 'Veuillez utiliser WeChat pour scanner et partager',
    shareLinkCopied: 'Lien de partage copié',
    sharePrefix: 'Bing Wallpaper : '
  },
  about: {
    title: 'À propos de Bing Wallpaper',
    subtitle: 'Un magnifique site de galerie de fonds d\'écran Bing avec de riches fonctionnalités de navigation, filtrage et téléchargement.',
    timeline1Title: 'Toutes les pages améliorées',
    timeline2Title: 'Première version, mise en page de base terminée',
    timeline3Title: 'Correction du bug d\'affichage de la pagination',
    timeline4Title: 'Refonte complète',
    timeline4Item1: '1. Mise en page de liste améliorée pour une meilleure esthétique et une utilisation plus simple',
    timeline4Item2: '2. Correction du bug de pagination (ne fonctionne plus sur un bug !!!)',
    timeline4Item3: '3. Filtrage multidimensionnel des fonds d\'écran : région, résolution, année, etc.',
    timeline4Item4: '4. Téléchargement groupé en un clic de tous les fonds d\'écran d\'une année filtrée',
    frontendProject: 'Projet frontend : ',
    backendProject: 'Projet backend : ',
    backendTutorial: 'Tutoriel backend : ',
    selfBuildApi: 'API Bing auto-hébergée',
    postPara1: 'Le backend utilise la base de données documentaire {link}MongoDB{/link} pour le stockage des données, l\'outil CI/CD illimité {link2}GitHub Actions{/link2} pour récupérer les données quotidiennes des fonds d\'écran et les stocker dans MongoDB, le framework Python asynchrone haute performance {link3}FastAPI{/link3} comme backend, et {link4}Vercel{/link4} pour le traitement serverless des requêtes. Le frontend utilise le framework {link5}Element UI{/link5} pour un développement rapide.',
    postPara2: 'Quand j\'ai découvert les fonds d\'écran Bing, j\'ai vu beaucoup de superbes fonds d\'écran sur Bing et je voulais une API pour l\'arrière-plan de mon blog. Plus tard, j\'ai appris à construire ma propre API. En cours de route, j\'ai beaucoup appris : la bibliothèque pymongo, la configuration de FastAPI, la conception modulaire Python ; frontend : mise en page de navigation, intégration de bibliothèque d\'icônes, utilisation de vue-router, encapsulation de requêtes axios, chargement de pagination.',
    postPara3: 'Il y a eu de nombreux défis aussi. J\'ai fait beaucoup de recherches pour découvrir que l\'API de fonds d\'écran Bing supportait les régions, mais la région Chine était redirigée de force. Vercel a pris longtemps à comprendre pour gérer à la fois le frontend et le backend ensemble. FastAPI avait de nombreux pièges. Il a fallu beaucoup de temps de recherche et d\'étude des conceptions d\'autres pour terminer la conception modulaire Python. J\'ai lu {link}Element UI{/link} d\'innombrables fois, rencontré de nombreux bugs, compris vue-router en suivant les exemples officiels, et la pagination avait encore un bug non résolu — PS : ce bug ne peut pas être retiré, le projet fonctionne dessus.',
    postPara4: '{strong}AI{/strong} est absolument incroyable !!!',
    postPara5: 'Maintenant, bing-wallpaper a intégré le système de commentaires {link}Twikoo{/link}. N\'hésitez pas à laisser vos pensées !'
  },
  seo: {
    siteName: 'Bing Wallpaper',
    defaultTitle: 'Bing Wallpaper | Fonds d\'écran HD quotidiens | Télécharger des fonds d\'écran du monde entier',
    defaultDescription: 'Site de téléchargement Bing Wallpaper, fournissant des fonds d\'écran HD quotidiens Microsoft Bing, supportant la navigation et le téléchargement multi-régions et multi-résolutions.',
    homeTitle: 'Bing Wallpaper | Fonds d\'écran HD quotidiens | Télécharger des fonds d\'écran du monde entier',
    homeDescription: 'Site de téléchargement Bing Wallpaper, fournissant des fonds d\'écran HD quotidiens Microsoft Bing, supportant 9 régions dont la Chine, les États-Unis, le Japon, l\'Allemagne, le Royaume-Uni, la France, l\'Italie, le Canada, l\'Inde. Offre 4K, 1920x1080 et d\'autres résolutions, avec téléchargement groupé en un clic de tous les fonds d\'écran annuels.',
    regionTitle: 'Fonds d\'écran Bing régionaux',
    regionDescription: 'Parcourez et téléchargez des fonds d\'écran Bing HD quotidiens régionaux, supportant la Chine, les États-Unis, le Japon, l\'Allemagne, le Royaume-Uni, la France, l\'Italie, le Canada, l\'Inde et plus.',
    aboutTitle: 'À propos de nous',
    aboutDescription: 'Présentation du site Bing Wallpaper, fournissant des téléchargements de fonds d\'écran HD quotidiens Microsoft Bing, supportant la navigation et le téléchargement multi-régions et multi-résolutions. Toutes les images de ce site proviennent de la recherche Bing, uniquement à des fins d\'apprentissage et d\'usage personnel.',
    detailTitle: 'Détails du fond d\'écran',
    detailDescription: 'Page de détail Bing Wallpaper, voir les fonds d\'écran HD et supporter les téléchargements en plusieurs résolutions.',
    regionSeoTitle: '{name} Bing Wallpaper - Télécharger fond d\'écran HD quotidien {name}',
    regionSeoDesc: 'Téléchargement {name} Bing Wallpaper, fournissant des fonds d\'écran HD quotidiens Microsoft Bing région {name}, supportant 4K, 1920x1080 et d\'autres résolutions, téléchargement gratuit de fonds d\'écran HD pour bureau.',
    regionSeoKeywords: '{name} Bing Wallpaper,fond d\'écran {name},Bing Wallpaper,téléchargement fond d\'écran HD',
    detailSeoTitle: '{title} - {region} Bing Wallpaper HD Télécharger',
    detailSeoDesc: '{title}. {copyright} Publié le {date}{region}. Bing Wallpaper offre 4K, 1920x1080 et d\'autres résolutions en téléchargement gratuit.',
    detailSeoKeywords: '{title},{region} Bing Wallpaper,téléchargement fond d\'écran HD,bing wallpaper,{date}',
    detailSeoKeywordsNoRegion: '{title},Bing Wallpaper,téléchargement fond d\'écran HD,bing wallpaper,{date}',
    detailSeoTitleNoRegion: '{title} - Bing Wallpaper HD Télécharger',
    detailSeoFromRegion: ', région : {name}',
    siteJsonLdDesc: 'Site de téléchargement Bing Wallpaper, fournissant des fonds d\'écran HD quotidiens Microsoft Bing, supportant la navigation et le téléchargement multi-régions et multi-résolutions.',
    regionJsonLdDesc: 'Téléchargement de fonds d\'écran Bing HD quotidiens région {name}, supportant 4K, 1920x1080 et d\'autres résolutions.',
    breadcrumbHome: 'Accueil',
    breadcrumbRegion: '{name} Bing Wallpaper',
    defaultKeywords: 'Bing Wallpaper,fond d\'écran quotidien,téléchargement fond d\'écran HD,Microsoft Bing,Bing Wallpaper,fond d\'écran HD,fond d\'écran bureau,fond d\'écran 4K,téléchargement fond d\'écran',
    htmlTitle: 'Bing Wallpaper | Fonds d\'écran HD quotidiens | Télécharger des fonds d\'écran du monde entier',
    htmlDescription: 'Site de téléchargement Bing Wallpaper, fournissant des fonds d\'écran HD quotidiens Microsoft Bing, supportant 9 régions dont la Chine, les États-Unis, le Japon, l\'Allemagne, le Royaume-Uni, la France, l\'Italie, le Canada, l\'Inde. Offre 4K, 1920x1080 et d\'autres résolutions, avec téléchargement groupé en un clic de tous les fonds d\'écran annuels.',
    htmlKeywords: 'Bing Wallpaper,fond d\'écran quotidien,téléchargement fond d\'écran HD,Microsoft Bing,Bing Wallpaper,fond d\'écran HD,fond d\'écran bureau,fond d\'écran 4K,téléchargement fond d\'écran,Bing Wallpaper API,collection fonds d\'écran,fond d\'écran quotidien',
    htmlH1: 'Bing Wallpaper - Microsoft Bing fonds d\'écran HD quotidiens à télécharger',
    htmlP: 'Site de téléchargement Bing Wallpaper, fournissant des fonds d\'écran HD quotidiens Microsoft Bing, supportant 9 régions dont la Chine, les États-Unis, le Japon, l\'Allemagne, le Royaume-Uni, la France et plus. Supporte 4K, 1920x1080 et d\'autres résolutions, avec téléchargement groupé en un clic de tous les fonds d\'écran annuels.',
    twitterTitle: 'Bing Wallpaper | Fonds d\'écran HD quotidiens',
    twitterDesc: 'Téléchargement de fonds d\'écran HD quotidiens Microsoft Bing, supportant multi-régions et multi-résolutions.'
  }
}



// WEBPACK FOOTER //
// ./src/locale/fr-FR.js